import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../../../../environments/environment";
import { ProviderParking, ProviderParkingDto } from "../../../models/provider-parking/provider-parking.model";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { optionResponse } from "../../../models/form.model";
import { MapperProviderParkingService } from "../../../mappers/provider-parking/mapper-provider-parking.service";

@Injectable({
    providedIn: 'root',
})
export class ApiProviderParkingService {
    private baseUrl = environment.apiPrivateUrl;

    constructor(
        private cookieService: CookieService,
        private apiMethodService: ApiMethodService,
        private mapper: MapperProviderParkingService
    ) {}

    /**
     * ดึงข้อมูลรายชื่อผู้ให้บริการ (สำหรับ Dropdown)
     */
    getProviderList(): Observable<optionResponse> {
        const token = this.cookieService.get('token');
        return this.apiMethodService.request<optionResponse>(
            '/backoffice/GetProvider',
            'GET',
            this.baseUrl,
            {
                isConsoleLog: false,
                labelLog: 'GetProvider',
                token: token,
                headerOnly: false,
            },
        );
    }

    /**
     * ดึงข้อมูลรายการผู้ให้บริการทั้งหมด (สำหรับ Table)
     */
    getProviderParking(): Observable<ProviderParking[]> {
        const token = this.cookieService.get('token');
        return this.apiMethodService.request<ProviderParkingDto[]>(
            '/backoffice/GetProviderParking', 
            'GET',
            this.baseUrl,
            {
                isConsoleLog: true,
                labelLog: 'GetProviderParking',
                token: token,
                headerOnly: false,
            },
        ).pipe(
            map(dtos => (dtos || []).map(dto => this.mapper.mapProviderParkingFromDto(dto)))
        );
    }

    /**
     * สร้างหรือแก้ไขข้อมูลผู้ให้บริการ
     */
    createProviderParking(payload: ProviderParking): Observable<any> {
        const token = this.cookieService.get('token');
        const dto = this.mapper.mapProviderParkingToDto(payload);
        return this.apiMethodService.request<any>(
            '/backoffice/CreateProviderParking',
            'POST',
            this.baseUrl,
            {
                isConsoleLog: true,
                labelLog: 'CreateProviderParking',
                token: token,
                headerOnly: false,
                body: dto
            },
        );
    }
}